var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#fff"}},[_c('Banner'),_c('BrandsLogos'),_c('MeetTheTeam'),_c('ReviewsCount'),_c('Leaders'),_c('MissionVision'),_c('OurValues'),_c('History'),_c('OurAwards'),_c('TypeDiv'),_c('Const')],1)}
var staticRenderFns = []

export { render, staticRenderFns }